// ==========================================================================
// 📡 REST API (Data Logic) - Gorras / Trileros
// ==========================================================================

const apiCall = async (endpoint, payload = null) => {
    try {
        const options = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        };
        if (payload) options.body = JSON.stringify(payload);

        const response = await fetch(`${process.env.REACT_APP_API_URL}Caps/${endpoint}`, options);
        if (response.ok) return { success: true };
        
        return { success: false, message: 'Error en la petición al servidor.' };
    } catch (error) {
        return { success: false, message: 'Error de red.' };
    }
};

export const ShowCapsFrontPageDL = () => apiCall('ShowFrontPage');
export const StartCapsGameDL = (config) => apiCall('Start', config);
export const ShuffleCapsGameDL = () => apiCall('Shuffle');
export const SelectCapAdminDL = (capId) => apiCall('Select', { capId, requestedBy: 'admin' });
export const SelectCapAficionadoDL = (capId) => apiCall('Select', { capId, requestedBy: 'aficionado' });
export const ResetCapsGameDL = () => apiCall('Reset');
export const EmergencyKickCapsPlayersDL = () => apiCall('EmergencyKick');